import React, { useEffect } from 'react';

const GiftCancelled = () => {
  useEffect(() => {
    // Clear any stored gift data since the purchase was cancelled
    localStorage.removeItem('pendingGift');
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="text-center max-w-2xl mx-auto">
        {/* Cancelled Animation Container */}
        <div className="bg-white border border-orange-200 rounded-3xl p-12 mb-8 shadow-2xl">
          {/* Animated Cancelled Icon */}
          <div className="mx-auto w-24 h-24 bg-gradient-to-r from-orange-600 to-red-600 rounded-full flex items-center justify-center mb-8 animate-pulse">
            <div className="text-4xl">❌</div>
          </div>
          
          {/* Cancelled Title */}
          <h1 className="text-4xl font-bold text-gray-900 mb-6">
            Gift Purchase Cancelled
          </h1>
          
          {/* Cancelled Message */}
          <div className="space-y-6 mb-8">
            <p className="text-xl text-gray-600">
              Your gift purchase was cancelled. No charges were made to your account.
            </p>
            
            {/* Need help section */}
            <div className="bg-orange-50 border border-orange-100 rounded-xl p-6">
              <p className="text-orange-700 font-semibold mb-3">Need help?</p>
              <ul className="text-gray-700 text-left space-y-2">
                <li className="flex items-center">
                  <span className="text-orange-600 mr-2">•</span>
                  Contact us if you have any questions
                </li>
                <li className="flex items-center">
                  <span className="text-orange-600 mr-2">•</span>
                  You can try purchasing again anytime
                </li>
                <li className="flex items-center">
                  <span className="text-orange-600 mr-2">•</span>
                  Check our FAQ for common issues
                </li>
              </ul>
            </div>
          </div>
          
          {/* Cancelled Emojis */}
          <div className="flex justify-center space-x-3 mb-8">
            <span className="text-3xl animate-bounce" style={{ animationDelay: '0ms' }}>❌</span>
            <span className="text-3xl animate-bounce" style={{ animationDelay: '100ms' }}>😔</span>
            <span className="text-3xl animate-bounce" style={{ animationDelay: '200ms' }}>💭</span>
            <span className="text-3xl animate-bounce" style={{ animationDelay: '300ms' }}>🤔</span>
            <span className="text-3xl animate-bounce" style={{ animationDelay: '400ms' }}>📞</span>
          </div>
        </div>
        
        {/* Action Buttons */}
        <div className="space-y-4">
          <a
            href="/"
            className="inline-block bg-gradient-to-r from-purple-600 to-purple-700 hover:from-purple-700 hover:to-purple-800 text-white font-bold py-4 px-8 rounded-xl transition duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl w-full"
          >
            Return to Home 🏠
          </a>
          <a
            href="/contact"
            className="inline-block bg-gradient-to-r from-gray-600 to-gray-700 hover:from-gray-700 hover:to-gray-800 text-white font-bold py-4 px-8 rounded-xl transition duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl w-full"
          >
            Contact Support 📞
          </a>
        </div>
      </div>
    </div>
  );
};

export default GiftCancelled; 